export const Plus = () => (
  <path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M12 6C11.5266 6 11.1428 6.38376 11.1428 6.85714V11.143H6.85714C6.38376 11.143 6 11.5267 6 12.0001C6 12.4735 6.38376 12.8573 6.85714 12.8573H11.1428V17.1429C11.1428 17.6162 11.5266 18 12 18C12.4734 18 12.8571 17.6162 12.8571 17.1429V12.8573H17.1429C17.6162 12.8573 18 12.4735 18 12.0001C18 11.5267 17.6162 11.143 17.1429 11.143H12.8571V6.85714C12.8571 6.38376 12.4734 6 12 6Z'
    fill='currentColor'
  />
)
